export enum PaymentProcessor {
  Adyen = 'Adyen',
  Chase = 'Chase',
  Eigen = 'Eigen',
  Elavon = 'Elavon',
  FirstDataNashville = 'FirstData Nashville',
  FirstDataNorth = 'FirstData North (RapidConnect)',
  FirstDataTampa = 'FirstData Tampa',
  GlobalCanada = 'Global Canada',
  Global = 'Global US',
  Heartland = 'Heartland',
  Moneris = 'Moneris',
  OloPay = 'OloPay',
  ParPayWP = 'ParPay WP',
  RevelAdvantage = 'Revel Advantage',
  Shift4 = 'Shift4',
  Stripe = 'Stripe',
  TdCanada = 'TD Canada',
  TsysSierra = 'TSYS (Sierra)',
  Worldpay = 'Worldpay',
}
